module.exports = __webpack_public_path__ + "img/poster.66d157a7.jpg";